import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import Layout from "../../components/layout/Layout";
import { useBreadcrumb } from "../../context/BreadcrumbContext";
import PropertyFinanceWorkspace from "./PropertyFinanceWorkspace";

export default function PropertyFinancePage() {
  const { propertyId } = useParams();
  const { setCustomPath, clearCustomPath } = useBreadcrumb();

  useEffect(() => () => clearCustomPath(), [clearCustomPath]);

  return (
    <Layout>
      <PropertyFinanceWorkspace
        propertyId={propertyId}
        showPageHeading
        onPropertyLoaded={(property) => {
          setCustomPath([
            { label: "Properties", path: "/properties" },
            { label: property?.name || "Property", path: `/properties/${propertyId}/details` },
            { label: "Finance", path: null },
          ]);
        }}
      />
    </Layout>
  );
}
